import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class LoaderComponent {
  loading$;
  message1$;
  message2$;
  transparentOverlay$;

  constructor(private loaderService: LoaderService) {
    this.loading$ = this.loaderService.loading$;
    this.message1$ = this.loaderService.message1$;
    this.message2$ = this.loaderService.message2$;
    this.transparentOverlay$ = this.loaderService.transparentOverlay$;
  }
}
